import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {rabbitMQ} from '../../../../../third/rabbitMQ';

class WorkerContrattiDaFornitoreModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    'store',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    'configuration',
    '$uibModal'
  ];

  private close: any;
  private dismiss: any;
  private settings: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService,
    private configuration: any,
    private $uibModal: ng.ui.bootstrap.IModalService
  ) {
    this.settings = $scope.$parent.$resolve.settings;
    $rootScope.filesUploadedNumber = 0;
    $scope.onProgress = true;
    $scope.ResponseReceived = false;
    $scope.ResponseReceivedTimeout = false;
    $scope.messageIcons = ['fa fa-circle-o-notch fa-spin fa-2x fa-fw',
      'fa fa-check-circle-o fa-2x fa-fw',
      'fa fa-exclamation-triangle fa-2x fa-fw orange',
      'fa fa-exclamation-circle fa-2x fa-fw red',
      '',
      'fa fa-check-circle-o fa-2x fa-fw green'
    ];
    $scope.messages = [];
    let receiveMessage = (message) => {
      let newMessage = JSON.parse(message);
      let messageExists = 0;
      for (let index = 0; index < $scope.messages.length; index++) {
        if ($scope.messages[index].messageId === newMessage.messageId) {
          $scope.messages[index] = newMessage;
          messageExists = 1;
          break;
        }
      }

      if (messageExists === 0) {
        $scope.messages.push(newMessage);
      }

    };

    let startWorker = (startWorkerLoops) => {
      try {
        if (rabbitMQ.client.STATE === 0) {
          if (startWorkerLoops < 3) {
            setTimeout(() => {
              startWorker(startWorkerLoops + 1);
            }, 3000);
          } else {

            let modalInstance = $uibModal.open({
              animation: $scope.animationsEnabled,
              component: 'defaultModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                config: () => {
                  return {
                    headerIcon: 'fa fa-exclamation-triangle',
                    headerText: 'Errore',
                    bodyText: 'Non è stato possibile avviare la comunicazione con il server. N° tentativi ' + startWorkerLoops,
                    buttons: [
                      {
                        'id': 1,
                        'icon': 'fa fa-ban',
                        'label': 'Annulla'
                      },
                      {
                        'id': 2,
                        'icon': 'fa fa-check-circle-o',
                        'label': 'Riprova'
                      }
                    ]
                  };
                }
              }
            });
            modalInstance.result.then((pressedButtonId) => {
              if (pressedButtonId !== undefined) {
                if (pressedButtonId === 1) {
                  this.close();
                }
                if (pressedButtonId === 2) {
                  startWorker(startWorkerLoops + 1);
                }
              }
            }, () => {
              // ?
            });
          }
          return 0;
        }

        this.settings.queueId = $rootScope.guid();
        this.settings.source = 'webApp';
        $scope.subscription = rabbitMQ.client.subscribe('subscription_contratti_da_fornitore' + '_' + this.settings.queueId, $scope.workerSubscriber);
        $rootScope.workerSubscriberActiveQueue = 'subscription_contratti_da_fornitore' + '_' + this.settings.queueId;
        rabbitMQ.send('worker_contratti_da_fornitore' + $rootScope.workerNameSuffix, JSON.stringify(this.settings));

        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;
        $rootScope.removeConservazioneSettingsFiles($scope.classeDocumentale);

        store.remove('conservazioneClasseDocumentale');

        $timeout(() => {
          if ($scope.messages.length === 0) {
            $scope.ResponseReceivedTimeout = true;
            $scope.ResponseReceived = false;
          }
        }, configuration.workerWaitTimeoutMilliseconds);
      } catch (err) {
        $rootScope.alert('error', err.message);
        return 0;
      }
      return 1;
    };
    $scope.workerSubscriber = (message) => {
      if (message.body === 'ok') {
        $scope.onProgress = false;
        $scope.ResponseReceived = true;
        $scope.subscription.unsubscribe();
        delete $rootScope.workerSubscriberActiveQueue;

        $scope.ok();
      } else {
        receiveMessage(message.body);
        $scope.ResponseReceivedTimeout = false;
      }
      $scope.$apply();
    };
    $scope.ok = () => {
      this.close();
      store.set('ConservazioneCaricaDocumento-Result', $scope.messages[$scope.messages.length - 1]);
      $state.go('home.conservazione-carica-documento-step3');
    };
    $scope.timeout = () => {
      $scope.subscription.unsubscribe();
      delete $rootScope.workerSubscriberActiveQueue;
      this.close();
      $state.go('home.conservazione');
    };
    $scope.cancel = () => {
      this.dismiss({$value: 'cancel'});
    };
    startWorker(0);
  }
}

export const WorkerContrattiDaFornitoreModalComponent: ng.IComponentOptions = {
  template: require('../worker-versamento-modal/worker-versamento-modal.html'),
  controller: WorkerContrattiDaFornitoreModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-contratti-da-fornitore-modal/worker-contratti-da-fornitore-modal.ts